var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title"},[_vm._v("Вы почти у цели. Осталось подтвердить компетенции и навыки")]),_c('router-link',{staticClass:"btn",attrs:{"to":"/account/competences/#todo-replace-link"}},[_vm._v("Подтвердить")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }